module.exports = __webpack_public_path__ + "static/img/partner-yf.b5167b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-yf.png
// module id = 4/2F
// module chunks = 34